module.exports = __webpack_public_path__ + "img/dep_snacks@2x.e6a8a134.png";